import { render, staticRenderFns } from "./GeneralTermsAndConditions.vue?vue&type=template&id=65e1438b&scoped=true&"
import script from "./GeneralTermsAndConditions.vue?vue&type=script&lang=js&"
export * from "./GeneralTermsAndConditions.vue?vue&type=script&lang=js&"
import style0 from "./GeneralTermsAndConditions.vue?vue&type=style&index=0&id=65e1438b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65e1438b",
  null
  
)

/* custom blocks */
import block0 from "./GeneralTermsAndConditions.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardText,VCol,VImg,VRow})
